import * as actionTypes from '../action-types'

export const updateNewAgreement = payload => {
  return {
    type: actionTypes.UPDATE_NEW_AGREEMENT,
    payload
  }
}

export const resetNewAgreement = () => {
  return {
    type: actionTypes.RESET_NEW_AGREEMENT
  }
}

export const updateSelectedAgreement = payload => {
  return {
    type: actionTypes.UPDATE_SELECTED_AGREEMENT,
    payload
  }
}

export const updateAgreementPurposes = payload => {
  return {
    type: actionTypes.UPDATE_AGREEMENT_PURPOSES,
    payload
  }
}

export const resetSelectedAgreement = () => {
  return {
    type: actionTypes.RESET_SELECTED_AGREEMENT
  }
}

export const updateSelectedRefs = payload => {
  return {
    type: actionTypes.UPDATE_SELECTED_REFS,
    payload
  }
}

export const resetSelectedRefs = payload => {
  return {
    type: actionTypes.RESET_SELECTED_REFS
  }
}

export const updateAgreementsList = payload => {
  return {
    type: actionTypes.UPDATE_AGREEMENTS_LIST,
    payload
  }
}

export const updateAgreementTableSort = payload => {
  return {
    type: actionTypes.UPDATE_AGREEMENT_TABLE_SORT,
    payload
  }
}



// WEBPACK FOOTER //
// ./src/redux-store/actions/agreement-actions.js